import React from "react";
import { Outlet, ScrollRestoration } from "react-router-dom";
import CustomerNav from "./components/CustomerNav";
import CustomerFooter from "./components/CustomerFooter";
import { I18nProvider } from "./i18n";
import { BookingProvider } from "./BookingContext";
import { CustomerAuthProvider } from "./AuthContext";
import { ThemeProvider } from "./ThemeContext";

export default function CustomerLayout() {
  return (
    <I18nProvider>
      <ThemeProvider>
        <CustomerAuthProvider>
          <BookingProvider>
            <div className="customer-site min-h-screen flex flex-col bg-white dark:bg-zinc-950 dark:text-zinc-100 transition-colors">
              <CustomerNav />
              <main className="flex-1">
                <Outlet />
              </main>
              <CustomerFooter />
              <ScrollRestoration />
            </div>
          </BookingProvider>
        </CustomerAuthProvider>
      </ThemeProvider>
    </I18nProvider>
  );
}
